/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-12-27 17:24:07
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-04 10:04:05
 */

import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { nanoid, unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Space,
  Upload,
} from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { RcFile } from 'antd/lib/upload'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  getFileUploadToken,
  uploadFileCloud,
} from '../../compnents/file/fileSlice'
import { OssParams } from '../../models/ossparams'
import { getOssUrl } from '../DepartmentManagement/departmentManagementSlice'
import { getUrl } from '../hospitalIntroduce/hospitalIntroduceSlice'
import styles from './DoctorManagement.module.css'
import {
  getDoctorManagementDetail,
  getDoctorManagementEditSubmit,
} from './doctorManagementSlice'

interface editDetailModalProps {
  id: any
  visible: boolean
  onCancel: () => void
  onOk: () => void
}
export const EditDetailModal = ({
  id,
  visible,
  onCancel,
  onOk,
}: editDetailModalProps): ReactElement => {
  const [form] = Form.useForm()

  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch<RootDispatch>()

  const [imageUrl, setImageUrl] = useState<any>()

  const [imageUrl2, setImageUrl2] = useState<any>()

  const [detail, setDetail] = useState<any>()

  useEffect(() => {
    if (visible) {
      dispatch(getDoctorManagementDetail(id))
        .then(unwrapResult)
        .then((v) => {
          setDetail(v)
        })
    }
  }, [visible])

  useEffect(() => {
    if (detail) {
      form.setFieldsValue({
        ...detail,
        onlineFollowUpVisitsFee:
          detail?.onlineFollowUpVisitsFee == -1
            ? ''
            : detail?.onlineFollowUpVisitsFee,
        graphicConsultationFee:
          detail?.graphicConsultationFee == -1
            ? ''
            : detail?.graphicConsultationFee,
        telephoneConsultationFee:
          detail?.telephoneConsultationFee == -1
            ? ''
            : detail?.telephoneConsultationFee,
        selfTitle: detail?.selfTitle ? detail?.selfTitle : detail?.jobTitle,
      })
      setImageUrl(detail.headPhoto)
      setImageUrl2(detail.headPhoto2)
    }
  }, [detail])

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>上传照片</div>
    </div>
  )

  return (
    <Modal
      title='编辑医生'
      width={600}
      visible={visible}
      // destroyOnClose
      onCancel={() => {
        onCancel()
        form.resetFields()
        setImageUrl('')
        setImageUrl2('')
        setDetail({})
      }}
      centered
      footer={null}
      className={styles.editRemark}
      maskStyle={{
        overflow: 'hidden',
      }}
    >
      <Form
        className={styles.form}
        form={form}
        onFinish={(values) => {
          dispatch(
            getDoctorManagementEditSubmit({
              ...detail,
              ...values,
              headPhoto: imageUrl,
              headPhoto2: imageUrl2,
            })
          )
            .then(unwrapResult)
            .then((v) => {
              notification.success({
                message: '操作成功',
                duration: 3,
              })
              onOk()
              form.resetFields()
              setDetail({})
              setImageUrl('')
              setImageUrl2('')
            })
        }}
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 20,
        }}
      >
        <Form.Item label='医生姓名' name='name'>
          <Input style={{ width: '300px' }} disabled={true} />
        </Form.Item>
        <Form.Item
          label='长方形头像'
          name='headPhoto'
          rules={[{ required: true, message: '请上传长方形头像' }]}
        >
          <Row>
            <Col>
              <Upload
                beforeUpload={(file) => {
                  if (file.size / 1024 < 2000) {
                    return true
                  } else {
                    notification.info({ message: '图片大于2Mb,请重新选择!' })
                    return false
                  }
                }}
                accept={'.png,.jpg,.jpeg,bmp'}
                name='avatar'
                listType='picture-card'
                className='avatar-uploader'
                showUploadList={false}
                customRequest={async ({ file }) => {
                  if (file) {
                    const formData = new FormData()
                    // 向 FormData 中添加新的属性值 append()方法
                    formData.append('file', file)
                    dispatch(getOssUrl(formData))
                      .then(unwrapResult)
                      .then((v) => {
                        setImageUrl(v)
                      })
                      .catch(() => {
                        return
                      })
                  }
                }}
              >
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt='avatar'
                    style={{ width: '100%', maxHeight: '102px' }}
                  />
                ) : (
                  uploadButton
                )}
              </Upload>
            </Col>
            <Col
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                fontSize: '14px',
                color: '#cbcacb ',
                margin: '0  0 4px 10px',
              }}
            >
              支持.jpg、.png、.jpeg等图片格式
              {/* <br /> 科室头像为空时用系统默认头像 */}
            </Col>
          </Row>
        </Form.Item>
        <Form.Item
          label='正方形头像'
          name='headPhoto2'
          rules={[{ required: true, message: '请上传正方形头像' }]}
        >
          <Row>
            <Col>
              <Upload
                beforeUpload={(file) => {
                  if (file.size / 1024 < 2000) {
                    return true
                  } else {
                    notification.info({ message: '图片大于2Mb,请重新选择!' })
                    return false
                  }
                }}
                accept={'.png,.jpg,.jpeg,bmp'}
                name='avatar'
                listType='picture-card'
                className='avatar-uploader'
                showUploadList={false}
                customRequest={async ({ file }) => {
                  if (file) {
                    const formData = new FormData()
                    // 向 FormData 中添加新的属性值 append()方法
                    formData.append('file', file)
                    dispatch(getOssUrl(formData))
                      .then(unwrapResult)
                      .then((v) => {
                        setImageUrl2(v)
                      })
                      .catch(() => {
                        return
                      })
                  }
                }}
              >
                {imageUrl2 ? (
                  <img
                    src={imageUrl2}
                    alt='avatar'
                    style={{ width: '100%', maxHeight: '102px' }}
                  />
                ) : (
                  uploadButton
                )}
              </Upload>
            </Col>
            <Col
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                fontSize: '14px',
                color: '#cbcacb ',
                margin: '0  0 4px 10px',
              }}
            >
              支持.jpg、.png、.jpeg等图片格式
              {/* <br /> 科室头像为空时用系统默认头像 */}
            </Col>
          </Row>
        </Form.Item>
        {/* <Form.Item
          label='擅长'
          name='adeptAt'
          rules={[{ required: true, message: '请输入擅长' }]}
        >
          <Input.TextArea
            style={{ width: '400px' }}
            maxLength={500}
            rows={3}
            showCount
          />
        </Form.Item> */}
        <Form.Item label='自定义职称' name='selfTitle'>
          <Input style={{ width: '300px' }} />
        </Form.Item>
        <Form.Item
          label='挂号费'
          name='selfFee'
          rules={[{ required: true, message: '挂号费不能为空' }]}
        >
          <Input style={{ width: '300px' }} />
        </Form.Item>
        <Form.Item
          label='门诊时间'
          name='selfTime'
          rules={[{ required: true, message: '门诊时间不能为空' }]}
        >
          <Input style={{ width: '300px' }} />
        </Form.Item>
        <Form.Item
          label='在线复诊费'
          name='onlineFollowUpVisitsFee'
          rules={[
            {
              pattern: /^[0-9]\d*(\.\d+)?$|^0\.\d+$/,
              message: '请输入数字',
            },
          ]}
        >
          <Input style={{ width: '300px' }} type='number' />
        </Form.Item>
        <Form.Item
          label='图文咨询费'
          name='graphicConsultationFee'
          rules={[
            {
              pattern: /^[0-9]\d*(\.\d+)?$|^0\.\d+$/,
              message: '请输入数字',
            },
          ]}
        >
          <Input style={{ width: '300px' }} type='number' />
        </Form.Item>
        <Form.Item
          label='电话咨询费'
          name='telephoneConsultationFee'
          rules={[
            {
              pattern: /^[0-9]\d*(\.\d+)?$|^0\.\d+$/,
              message: '请输入数字',
            },
          ]}
        >
          <Input style={{ width: '300px' }} type='number' />
        </Form.Item>
        <Form.Item label='简介' name='intro'>
          <Input.TextArea
            disabled={true}
            style={{ width: '400px' }}
            maxLength={500}
            rows={3}
            showCount
          />
        </Form.Item>
        <Form.Item label='主治' name='majorFunction'>
          <Input.TextArea
            disabled={true}
            style={{ width: '400px' }}
            maxLength={500}
            rows={3}
            showCount
          />
        </Form.Item>
        <Form.Item label='自定义简介' name='customizeIntro'>
          <Input.TextArea
            style={{ width: '400px' }}
            maxLength={500}
            rows={3}
            showCount
          />
        </Form.Item>
        <Form.Item label='自定义主治' name='customizeMajorFunction'>
          <Input.TextArea
            style={{ width: '400px' }}
            maxLength={500}
            rows={3}
            showCount
          />
        </Form.Item>
        <div style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
          <Space>
            <Button onClick={() => onCancel()}>取消</Button>
            <Button type='primary' htmlType='submit'>
              确定
            </Button>
          </Space>
        </div>
      </Form>
    </Modal>
  )
}
